import LuiTable from './table'
import LuiForm from './form'
import LuiModal from './modal'
import LuiFormItem from './formItem.vue'
const plugins = {
    install (Vue){
        Vue.component('LuiTable',LuiTable)
        Vue.component('LuiForm',LuiForm)
        Vue.component('LuiFormItem',LuiFormItem)
        Vue.component('LuiModal',LuiModal)
    }
}

export default plugins


// WEBPACK FOOTER //
// ./src/lib/index.js